export const getHeaders = () => {
  return [
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "art_codigo", headerName: "Codigo", width: 100 },
    { field: "art_descripcion", headerName: "Descripcion", width: 350 },
    { field: "ajud_stockactual", headerName: "Stock Anterior", width: 120 },
    { field: "ajud_stockreelevado", headerName: "Stock Reelevado", width: 120 },
    {
      field: "ajud_obs",
      headerName: "Observación",
      width: 150,
      renderCell: (params) => {
        const texto = params.value;
        if (!texto) return null;

        return (
          <button
            style={{
              backgroundColor: "#1976d2",
              color: "#fff",
              border: "none",
              padding: "4px 8px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => params.api.getRow(params.id)?.handleOpenModalObs(texto)}
          >
            Ver
          </button>
        );
      }
    },
  ];
};


